<template>
	<div>
		<div class="supervisorRank">
			<div class="titleIcon marb25">
				<div class="inlin">
					<i :class="`iconfont ${icon} tableIcon`"></i>
					<span class="fz16">{{title}}</span>
				</div>
				<div class="exportTab marl20">
					<div class="sliderScreeningR">
						<a href="javascript:;" @click="seachTab(1)" :class="DashboradArr.type==1?'active':''">全部</a>
						<a href="javascript:;" @click="seachTab(2)" :class="DashboradArr.type==2?'active':''">严重</a>
					</div>
				</div>
			</div>
			<div class="mart25 postr">
				<template>
					<el-table class="qcTable qcHeight scrollbar" :data="newList" height="285">
						<template slot="empty">
							<div class="echartsNull">
								<div>
									<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
								</div>
								<div class="text">暂无数据</div>
							</div>
						</template>
					<!-- 	<el-table-column prop="index" label="序号" align="center" width="80">
							<template slot-scope="scope">
								<span>{{(currentPage - 1) * pagesize + scope.$index + 1}}</span>
							</template>
						</el-table-column> -->
						<el-table-column prop="Desc" label="评分细则" show-overflow-tooltip></el-table-column>
						<el-table-column prop="Count" label="数量"></el-table-column>
						<el-table-column prop="Percent" label="扣分占比">
							<template slot-scope="scope" slot="header">
								<el-tooltip class="item" effect="dark" content="扣分占比 = 扣分次数/抽样数量"
									placement="bottom">
									<span>
										扣分占比 <i class="el-icon-info" style="color: #248AFD;"></i>
									</span>
								</el-tooltip>
							</template>
							<template slot-scope="scope">
								{{scope.row.Percent }}
							</template>
						</el-table-column>
						<el-table-column prop="PersonPercent" label="人数占比">
							<template slot-scope="scope" slot="header">
								<el-tooltip class="item" effect="dark" content="人数占比 = 此细则出错的人数/总人数"
									placement="bottom">
									<span>
										人数占比 <i class="el-icon-info" style="color: #248AFD;"></i>
									</span>
								</el-tooltip>
							</template>
							<template slot-scope="scope">
								{{scope.row.PersonPercent }}
							</template>
						</el-table-column>
						<el-table-column prop="MultiPersonPercent" label=">2次人数占比" width="160">
							<template slot-scope="scope" slot="header">
								<el-tooltip class="item" effect="dark" content="多次人数占比 = 此细则出现2次扣分以上的人数/总人数"
									placement="bottom">
									<span>
										>2次人数占比 <i class="el-icon-info" style="color: #248AFD;"></i>
									</span>
								</el-tooltip>
							</template>
							<template slot-scope="scope">
								{{scope.row.MultiPersonPercent }}
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<span class="tableOpe" @click="qualifiedClick(scope.row,'qualified')">查看报告</span>
							</template>
						</el-table-column>
					</el-table>
				</template>
				<div class="pages">
					<el-pagination class="pageAll" align="center" layout="prev, pager, next" :total="total"
						:page-size='pagesize' :current-page='currentPage' @current-change='currentChange'>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		props: ['allItems', 'seriousItems', 'icon', 'title','type','list','tabType'],
		data() {
			return {
				pagesize: 6,
				total: 0,
				currentPage: 1,
				DashboradArr: {
					type: 1
				},
				newList:[]
			}
		},
		computed: {
			...Vuex.mapState('centralStatistics', ['trigger','hospitalResultParameter', 'reportDate']),
			...Vuex.mapState('supervisor', ['QualifiedPart', 'breadcrumbList', 'GetReportListArr']),
			triggers() {
				return this.trigger.flag;
			}
		},
		watch: {
			triggers(old) {
				if (old) {
					this.seachTab(1);
				}
			},
			type(old,news){
				if(old){
					this.trigger.flag = false;
					this.seachTab(1);
				}
			},
			list(old,news){
				if (old) {
					this.changePage(this.list);
				}
			},
			currentPage(old,news){
				if(old){
					this.changePage(this.DashboradArr.type == 1?this.allItems:this.seriousItems);
				}
			}
		},
		activated(){
			if (this.tabType) {
				this.seachTab(1);
			}else{
				this.seachTab(this.DashboradArr.type);
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'settableLoading','setLoading', 'setBreadcrumbList']),
			changePage(list){
				this.total = list.length;
				this.newList = list.slice((this.currentPage-1)*this.pagesize,this.currentPage*this.pagesize);
			},
			qualifiedClick(row, type) {
				this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.QualifiedPart.hospitalGuid = this.hospitalResultParameter.hospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = type;
				this.QualifiedPart.itemDesc = row.Desc;
				this.QualifiedPart.descType = this.DashboradArr.type;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.breadcrumbList.push(this.reportDate.data[0] + '-' + this.reportDate.data[1]);
				this.breadcrumbList.push(row.Desc);
				this.$router.push("/home/supervisor/qualifiedTable");
				this.breadcrumbList.push("itemDesc");
			},
			currentChange(val) {
				this.currentPage = val;
			},
			seachTab(type){
				this.DashboradArr.type = type;
				this.newList = type == 1?this.allItems:this.seriousItems;
				if (this.newList.length>0) {
					this.currentPage = 1;
				}
				this.changePage(this.newList);
			}
		},
	}
</script>
<style type="text/css">
	.bigScreen .supervisorPages .supervisorRank {
		padding-left: 20px;
		padding-right: 20px;
	}

	.doctorPage .pages {
		margin: 20px 0 0;
	}
</style>
